import { IGeneralDataContext } from './GeneralDataContext';
import { ControllerFlowAPI } from 'yoshi-flow-editor-runtime/build/cjs/flow-api/ViewerScript';

export interface IGeneralDataProviderProps extends IGeneralDataContext {}

export function generalDataProviderPropsMap(
  flowAPI: ControllerFlowAPI,
): IGeneralDataProviderProps {
  const { appDefinitionId } = flowAPI.environment;
  const instance = flowAPI.controllerConfig.wixCodeApi.site.getAppToken(
    appDefinitionId,
  );

  return {
    instance,
    instanceId: flowAPI.controllerConfig.appParams.instanceId,
  };
}
